var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { ConditionPart } from '@easyquery/core';
import { BaseElementRenderer } from '../base_element_renderer';
var ExpressionRenderer = /** @class */ (function (_super) {
    __extends(ExpressionRenderer, _super);
    function ExpressionRenderer(panel, expression, valueEditor, slot) {
        var _this = _super.call(this, slot) || this;
        _this.panel = panel;
        _this.expression = expression;
        _this.valueEditor = valueEditor;
        return _this;
    }
    Object.defineProperty(ExpressionRenderer.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-qp';
        },
        enumerable: true,
        configurable: true
    });
    ExpressionRenderer.prototype.render = function (isEditMode) {
        if (isEditMode === void 0) { isEditMode = false; }
        _super.prototype.render.call(this, isEditMode);
        if (this.panel.options.onExpressionRendered) {
            this.panel.options.onExpressionRendered(this.expression, this.element);
        }
        return this.element;
    };
    ExpressionRenderer.prototype.getContext = function () {
        return this.panel.getContext();
    };
    ExpressionRenderer.prototype.isReadOnly = function () {
        var parent = this.expression.getParent();
        return !parent.enabled || parent.isReadOnly();
    };
    ExpressionRenderer.prototype.isEditable = function () {
        return !this.isReadOnly();
    };
    ExpressionRenderer.prototype.getClassesToAdd = function () {
        return this.cssPrefix + "-condelement " + this.cssPrefix + "-valueelement";
    };
    ExpressionRenderer.prototype.getLabelText = function () {
        var result = !this.expression.isEmpty()
            ? this.expression.value
            : this.getEmptyText();
        return result;
    };
    ExpressionRenderer.prototype.getEmptyText = function () {
        return this.panel.options.emptyTextValue || i18n.getText('MsgEmptyScalarValue'); //'[enter value]';
    };
    ExpressionRenderer.prototype.setValue = function (value, silent) {
        this.expression.setValue(value);
        if (!silent) {
            this.expression.getParent().fireChangedEvent(ConditionPart.Value);
        }
    };
    ExpressionRenderer.prototype.getValue = function () {
        return this.expression.value;
    };
    ExpressionRenderer.prototype.validateInput = function (value) {
        return { success: true, value: value };
    };
    ExpressionRenderer.prototype.showValidationError = function (message, target) {
        this.getContext().throwError({
            action: "ui.validation",
            "text": message
        });
    };
    ExpressionRenderer.prototype.isEmptyValue = function () {
        var v = this.getValue();
        return (typeof (v) === "undefined" || v === null || !v);
    };
    ExpressionRenderer.prototype.adjustWidth = function () {
    };
    return ExpressionRenderer;
}(BaseElementRenderer));
export { ExpressionRenderer };
//# sourceMappingURL=expression_renderer.js.map